import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

const ViewPdfModal = ({ isOpen, onClose, pdfUrl }) => (
  <Modal isOpen={isOpen} onClose={onClose} size="6xl">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>Packing List PDF</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <iframe
          src={pdfUrl}
          title="Packing List PDF"
          width="100%"
          height="800px"
          style={{ border: "none" }}
        />
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default ViewPdfModal;
